import { SkapaTheme } from '@inter-ikea-kompis/themes/lib';
import styled from 'styled-components';

export const ArticleIdText = styled.div`
	background-color: ${SkapaTheme.color.component.primaryPress};
	color: white;
	padding: 4px;
	display: inline-block;
`;

export const ArticleNoText = styled.div`
	color: ${SkapaTheme.color.text.default};
	display: block;
	margin-bottom: ${SkapaTheme.spacing.space50}px;
`;

export const DescriptionHeadline = styled.div<{
	hasProductDescription: boolean;
}>`
	${(props): string => `
		margin-top: ${props.hasProductDescription ? 0 : '16px'};
		margin-bottom: 4px;
	`}
`;

export const MaterialDescription = styled.div`
	margin: 16px 0 4px 0;
`;

export const RemovableText = styled.div`
	margin-bottom: 8px;
`;

export const MaterialText = styled.p`
	margin: 4px 0 0 16px;
`;

export const MaterialWrapper = styled.div`
	margin-bottom: 4px;
`;
